import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card } from "react-md";
import MGrid, {
  ACTION_MAP,
  ACTION_CONFIGURE,
  ACTION_ADD,
  ACTION_DOWNLOAD
} from "components/Shared/MGrid.tsx";
import { AppInsightsTracker, MSpinner } from "components/Shared";
import { getInspectorPinURL } from "components/Shared/Map";
import { clearNullFromColumnDefs, getSearchParameter } from "components/Shared/Functions";
import MSplitter from "components/Shared/MSplitter.tsx";
import AppraiserProfilePanel from "containers/Appraiser/ProfilePanel";
import { APPRAISER_LIST_EXPORT } from "typeConstants/rights";
import { clearAppraiserProfile } from "actions/appraiser";

class AppraiserList extends AppInsightsTracker {
  constructor(props) {
    super(props);
    this.displayName = "AppraiserList";
    this.onCreate = this.onCreate.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.mapDataForMapControl = this.mapDataForMapControl.bind(this);
    this.navigateToAppraiser = this.navigateToAppraiser.bind(this);

    this.state = { appraiserId: null, internetUserId: null };
  }

  componentDidMount() {
    const { location } = this.props;
    this.props.getAppraiserList(getSearchParameter(location));
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const { isFetchingGridFilters, getAppraiserList, location } = this.props;
    if (!nextProps.isFetchingGridFilters && isFetchingGridFilters) {
      getAppraiserList(getSearchParameter(location));
    }
    const { appraiserList } = this.props;
    if (clearNullFromColumnDefs(appraiserList.columns) && !clearNullFromColumnDefs(nextProps.appraiserList.columns)) {
      getAppraiserList(getSearchParameter(location));
    }
  }

  componentWillUnmount() {
    // Clearing this out so that employee calendar doesn't display appraiser specific details once user has navigated away
    this.props.clearAppraiserProfile();
  }

  onCreate() {
    const {
      state: {
        searchText
      }
    } = this.props.location;
    this.props.history.push({
      pathname: "/appraiser/create",
      state: { 
        searchText,
      }
    });
  }

  onRowClick(rowIndex) {
    let row = this.props.appraiserList.rows[rowIndex];
    this.setState({
      appraiserId: row.id,
      internetUserId: row.internetUserId,
    });
  }

  navigateToAppraiser() {
    const {
      state: {
        searchText
      }
    } = this.props.location;
    let pathname = "/appraiser/profile";
    this.props.history.push({
      pathname: pathname,
      state: {
        id: this.state.appraiserId,
        internetUserId: this.state.internetUserId,
        searchText,
      }
    });
  }

  mapDataForMapControl(rowIndex) {
    let row = this.props.appraiserList.rows[rowIndex];
    return {
      latitude: row.latitude,
      longitude: row.longitude,
      iconURL: getInspectorPinURL(false, false)
    };
  }

  render() {
    const { isFetchingAppraiserList, appraiserList, profile } = this.props;
    if (isFetchingAppraiserList) {
      return <MSpinner />;
    }
    return (
      <MSplitter
        firstChild={
          <div className="padding-page-content full-height">
            <Card className="full-height">
              {isFetchingAppraiserList && <MSpinner />}
              {!isFetchingAppraiserList &&
                <MGrid
                  configurationId="AppraiserList"
                  headerText="Appraiser List"
                  columnDefinitions={clearNullFromColumnDefs(appraiserList.columns)}
                  data={appraiserList.rows}
                  isFetchingData={isFetchingAppraiserList}
                  actions={[ACTION_MAP, ACTION_CONFIGURE, { code: ACTION_ADD, onClick: this.onCreate }, ...(profile.rights.includes(APPRAISER_LIST_EXPORT) ? [ACTION_DOWNLOAD] : [])]}
                  draggableColumns
                  onRowClick={this.onRowClick}
                  getMapPinForRow={this.mapDataForMapControl}
                  displayNumOfItemsFound
                />
              }
            </Card>
          </div>}
        secondChild={
          (this.state.appraiserId && this.state.internetUserId) &&
          <AppraiserProfilePanel
            id={this.state.appraiserId}
            internetUserIdForPanel={this.state.internetUserId}
          />}
        secondChildTitle={{
          title: "Appraiser Profile",
          buttons: [
            { icon: "fullscreen", onClick: this.navigateToAppraiser },
            { icon: "close", onClick: () => this.setState({ appraiserId: null, internetUserId: null }) }
          ]
        }}
      />
    );
  }
}

AppraiserList.propTypes = {
  isFetchingAppraiserList: PropTypes.bool.isRequired,
  appraiserList: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  getAppraiserList: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object,
  // Redux
  clearAppraiserProfile: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  clearAppraiserProfile() {
    dispatch(clearAppraiserProfile());
  },
});

export default connect(null, mapDispatchToProps)(withRouter(AppraiserList));
